export default {
  'ECPAY_SINGLE_ATM': 'ATM轉帳繳款',
  'ECPAY_SINGLE_CVS': '超商代碼繳款',
  'ECPAY_SINGLE_CREDIT': '信用卡單次繳款',
  'ECPAY_PERIOD_CREDIT': '信用卡定期定額',
  'LINEPAY_SINGLE': 'LINE Pay',
  'JKOPAY_SINGLE': '街口支付單次捐款',
};